import React from 'react';
import PropTypes from 'prop-types';
import { CampaignOData } from '@bingads-webui-react/campaign-odata';
import { notificationApi } from '@bingads-webui-campaign/notification-center';
import { shellTips } from '@bingads-webui-campaign-react/shell-ui-common';

export const WithSharedBudgetRepository = ({
  campaignLoadFallback, budgetId, WrappedComponent, i18n, ...passThroughProps
}) => (
  <CampaignOData
    call={({ currentAccount }) => {
      const currentBudget = currentAccount.Budgets.$withKey(budgetId);
      return currentBudget.get();
    }}
    fallback={campaignLoadFallback}
    onError={() => {
      notificationApi.showWarning(i18n.getString(shellTips.shellDataError));
      return campaignLoadFallback;
    }}
  >
    { sharedBudgetFromOData =>
      (<WrappedComponent {...passThroughProps} sharedBudgetFromOData={sharedBudgetFromOData} />) }
  </CampaignOData>
);

WithSharedBudgetRepository.propTypes = {
  campaignLoadFallback: PropTypes.element.isRequired,
  budgetId: PropTypes.number.isRequired,
  WrappedComponent: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};
